import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import FacebookLogo from '@crehana/icons/FacebookLogo';
import GoogleIcon from '@crehana/icons/GoogleIcon';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, Tooltip } from '@crehana/ui';

import LoadingOverlay from '../components/LoadingOverlay';

const { white } = colors;

type SocialButtonsVariantMinimalV2Props = {
  shouldRenderFacebookButton: boolean;
  facebookButtonProps: {
    onClick: () => void;
  };
  gmailButtonProps: {
    id: string;
    ref: React.RefObject<HTMLButtonElement>;
  };
  processingSocialAuth: boolean;
  loadingFacebookAndGoogleScripts: boolean;
  currentForm?: string;
  hideFBAuthButton?: boolean;
  hideFBAuthLink?: boolean;
  nextUrl?: string;
  facebookLabel: string;
  googleLabel: string;
};
const SocialButtonsVariantMinimalV2: React.FC<
  React.PropsWithChildren<SocialButtonsVariantMinimalV2Props>
> = ({
  shouldRenderFacebookButton,
  facebookButtonProps,
  gmailButtonProps,
  processingSocialAuth,
  loadingFacebookAndGoogleScripts,
  hideFBAuthButton,
  hideFBAuthLink,
  nextUrl,
  facebookLabel,
  googleLabel,
}) => {
  const renderFBAuth = () => {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (hideFBAuthButton && hideFBAuthLink) return null;
    if (hideFBAuthButton && !hideFBAuthLink) {
      return (
        <Tooltip label={facebookLabel} position="bottom" type="regular">
          <a
            className="flex items-center justify-center w-48 h-48 bg-white rounded-full"
            href={`${CREHANA_BASE_URL_PRD}/login/facebook/?next=${nextUrl}`}
            {...facebookButtonProps}
          >
            <FacebookLogo size={28} color={white} />
          </a>
        </Tooltip>
      );
    }
    return (
      <Tooltip label={facebookLabel} position="bottom" type="regular">
        <button
          className="flex items-center justify-center w-48 h-48 bg-white rounded-full"
          type="button"
          {...facebookButtonProps}
        >
          <FacebookLogo size={28} />
        </button>
      </Tooltip>
    );
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-center m-auto max-w-280">
        {shouldRenderFacebookButton && renderFBAuth()}
        <Tooltip label={googleLabel} position="bottom" type="regular">
          <button
            className="flex items-center justify-center w-48 h-48 ml-40 bg-white rounded-full"
            type="button"
            style={{
              display: window.navigator.userAgent
                .toLowerCase()
                .includes('instagram')
                ? 'none !important'
                : 'flex',
            }}
            {...gmailButtonProps}
          >
            <GoogleIcon size={28} color={white} />
          </button>
        </Tooltip>
      </div>
      {(processingSocialAuth || loadingFacebookAndGoogleScripts) && (
        <LoadingOverlay />
      )}
    </div>
  );
};

export default SocialButtonsVariantMinimalV2;
